import { Route, Routes } from 'react-router-dom';
import { SalesOverviewNewPage } from "./inner-components";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const DashboardPage = () => {
  return (
    <div className="flexRow full p-0 m-0">
      <div className='full-flex flexCol width100 p-0 m-0'>
      <ToastContainer/>
        <Routes>
          <Route path="/" element={<SalesOverviewNewPage />} />
        </Routes>
      </div>
    </div>
  )
}